import {
	type OsobyKomunikacniUdajeDto,
	type ResponseError,
	robCommunicationQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import type { AxiosError } from 'axios';

export interface RobCommunicationQueryProps {
	onSuccess?: (data: OsobyKomunikacniUdajeDto) => void;
	onError?: (error: AxiosError<ResponseError>) => void;
	enabled?: boolean;
	cacheTime?: number;
	retry?: number;
}

export const robCommunicationQueryKey = ['person-communication'];

export const useRobCommunicationQuery = (
	props?: RobCommunicationQueryProps
) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: robCommunicationQueryKey,
		queryFn: () => robCommunicationQuery(axiosInstance),
		onSuccess: props?.onSuccess,
		onError: props?.onError,
		enabled: props?.enabled,
		cacheTime: props?.cacheTime,
		retry: props?.retry,
	});

	return query;
};
